module.exports = __webpack_public_path__ + "static/media/Group9236.c4733166.png";